import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum AgentTaskRelationshipKind {
  BLOCKED_BY = "blocked-by",
}

const agentTaskRelationshipSchema_ = z.object({
  _id: zExt.objectId(),
  sourceTaskId: zExt.objectId(),
  targetTaskId: zExt.objectId(),
  kind: createEnum(AgentTaskRelationshipKind, {
    enumName: "agent_task_relationship_kind",
  }),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const AgentTaskRelationshipSchema: z.ZodType<AgentTaskRelationship> =
  agentTaskRelationshipSchema_;
export interface AgentTaskRelationship
  extends z.infer<typeof agentTaskRelationshipSchema_> {}
